import React from "react";
import { Form, Input, Select, Tooltip } from "antd";
import { getDigitsOnly } from "../../../utils";

const { Option } = Select;

interface DealGridFormProps {
	form: any;
	wholeData: {
		channelData: Array<{ key: string; id: string; name: string; active: boolean }>;
		partnerData: Array<{ key: string; id: string; name: string; active: boolean }>;
		platformData: Array<{ key: string; id: string; name: string; active: boolean }>;
		territoryData: Array<{ key: string; id: string; name: string; active: boolean }>;
	};
}

const DealsForm: React.FC<DealGridFormProps> = ({ form, wholeData }) => {
	const { partnerData, platformData } = wholeData;

	return (
		<>
			<Form.Item
				label="ID"
				name="id"
				rules={[{ required: true, message: "Please input the Deal Parent!" }]}
			>
				<Input onChange={e => form.setFieldValue("deal_parent", getDigitsOnly(e.target.value))} />
			</Form.Item>

			<Form.Item
				label="Platform"
				name="platform_id"
				rules={[{ required: true, message: "Please select a platform!" }]}
			>
				<Select placeholder="Select a platform" allowClear showSearch>
					{platformData.map(platform => (
						<Option key={platform.key} value={platform.id}>
							{platform.name}
						</Option>
					))}
				</Select>
			</Form.Item>

			<Form.Item
				label="Partner"
				name="partner_id"
				rules={[{ required: true, message: "Please select a partner!" }]}
			>
				<Select allowClear showSearch placeholder="Select a partner">
					{partnerData.map(partner => (
						<Option key={partner.key} value={partner.id}>
							{partner.name}
						</Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Domain"
				name="domain"
				rules={[{ required: true, message: "Please select a domain!" }]}
			>
				<Select allowClear showSearch placeholder="Select a domain">
					<Option value="Distribution Partners">Distribution Partners</Option>
					<Option value="Owned and Operated" disabled>Owned and Operated</Option>
				</Select>
			</Form.Item>
			<Form.Item
				label="Viewership Type (Optional)"
				name="viewership_type"
			>
				<Select placeholder="Linear/VOD" allowClear mode="multiple">
					<Option key='Linear' value="Linear">
						Linear
					</Option>
					<Option key='VOD' value="VOD">
						VOD
					</Option>
				</Select>
			</Form.Item>
		</>
	);
};

export default DealsForm;
